import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { tradingNameParser } from "src/lib/utils";

export default function Breadcrumbs({ name }) {
  const router = useRouter();

  return (
    <Breadcrumb
      spacing="8px"
      separator={<ChevronRightIcon color="gray.300" />}
      mb={4}
      color={"gray.300"}
    >
      <BreadcrumbItem ml={0}>
        <BreadcrumbLink
          ml={0}
          fontWeight={"normal"}
          onClick={() => router.back()}
        >
          Search Results
        </BreadcrumbLink>
      </BreadcrumbItem>

      <BreadcrumbItem isCurrentPage ml={0}>
        <Text ml={0}>{tradingNameParser(name)}</Text>
      </BreadcrumbItem>
    </Breadcrumb>
  );
}
